// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"eeab3870","532":"a5ef1194","820":"a2892367"}[chunkId] + ".chunk.js";
};